<template><div><h1>VUX V2.1.1Rc.9 发布日志</h1>
<h2><a href="/zh-CN/components/alert.html">Alert</a></h2>
<ul><li>[fix] 修正 onHide 回调被错误调用 #1023 @jsonviewer</li>
</ul>
<h2><a href="/zh-CN/components/datetime-range.html">DatetimeRange</a></h2>
<ul><li>[feature] 新组件 #970 @327326724</li>
</ul>
<h2><a href="/zh-CN/components/popup.html">Popup</a></h2>
<ul><li>[enhance] 更流畅的遮罩层动画</li>
<li>[feature] 支持透明背景</li>
<li>[feature] 支持背影颜色变量 @popup-background-color</li>
</ul>
<h2><a href="/zh-CN/components/swipeout.html">Swipeout</a></h2>
<ul><li>[fix] 修复向右快速滑动时左侧菜单可能会被滑出</li>
</ul>
<h2><a href="/zh-CN/components/toast.html">Toast</a></h2>
<ul><li>[enhance] 插件调用时每次都重置为默认参数 #870 @jsonviewer</li>
</ul>
<h2><a href="/zh-CN/components/date.html">Date</a></h2>
<ul><li>[feature] 添加日期范围生成函数</li>
<li>[feature] format 函数支持字符串参数</li>
</ul>
<h2><a href="/zh-CN/components/number.html">Number</a></h2>
<ul><li>[feature] 添加数字范围生成函数</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.1Rc.9 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.9-217.vue?07861558